import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Country } from 'app/core/models/country';


@Component({
  selector: 'app-base',
  template: `NO UI TO BE FOUND HERE !`,
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {

  public countrys: Array<Country> = [
    { countryCode: "AT", countryLabel: "COUNTRY_AT" },
    { countryCode: "BE", countryLabel: "COUNTRY_BE" },
    { countryCode: "BG", countryLabel: "COUNTRY_BG" },
    { countryCode: "HR", countryLabel: "COUNTRY_HR" },
    { countryCode: "CY", countryLabel: "COUNTRY_CY" },
    { countryCode: "CZ", countryLabel: "COUNTRY_CZ" },
    { countryCode: "DK", countryLabel: "COUNTRY_DK" },
    { countryCode: "EE", countryLabel: "COUNTRY_EE" },
    { countryCode: "FI", countryLabel: "COUNTRY_FI" },
    { countryCode: "FR", countryLabel: "COUNTRY_FR" },
    { countryCode: "DE", countryLabel: "COUNTRY_DE" },
    { countryCode: "GR", countryLabel: "COUNTRY_GR" },
    { countryCode: "HU", countryLabel: "COUNTRY_HU" },
    { countryCode: "IE", countryLabel: "COUNTRY_IE" },
    { countryCode: "IT", countryLabel: "COUNTRY_IT" },
    { countryCode: "LV", countryLabel: "COUNTRY_LV" },
    { countryCode: "LT", countryLabel: "COUNTRY_LT" },
    { countryCode: "LU", countryLabel: "COUNTRY_LU" },
    { countryCode: "MT", countryLabel: "COUNTRY_MT" },
    { countryCode: "NL", countryLabel: "COUNTRY_NL" },
    { countryCode: "PL", countryLabel: "COUNTRY_PL" },
    { countryCode: "PT", countryLabel: "COUNTRY_PT" },
    { countryCode: "RO", countryLabel: "COUNTRY_RO" },
    { countryCode: "SK", countryLabel: "COUNTRY_SK" },
    { countryCode: "SI", countryLabel: "COUNTRY_SI" },
    { countryCode: "ES", countryLabel: "COUNTRY_ES" },
    { countryCode: "SE", countryLabel: "COUNTRY_SE" },
    { countryCode: "CH", countryLabel: "COUNTRY_CH" },
    { countryCode: "GB", countryLabel: "COUNTRY_GB" },
    { countryCode: "UA", countryLabel: "COUNTRY_UA" }
  ];

  public transactionStatus: Array<string> = ["CANCELLED", "CAPTURED", "CREDITED", "ENDED", "EXPIRED", "INITIALIZING", "INITIALIZED",
    "PENDING", "REFUSED", "AUTHORIZED", "TO_AUTHORIZE", "TO_CAPTURE","CAPTURE_PENDING","CAPTURE_ERROR",
    "TO_CANCEL", "TO_CHALLENGE", "TO_CREDIT", "TO_VALIDATE", "UNDEFINED"];

  public transactionStates: Array<string> = ["INITIALIZING", "INITIALIZED", "IN_PROGRESS", "COMPLETE", "CANCELLED",
    "ABORTED", "ABORTING_ERROR"];

  public paymentProviderList: Array<string> = ["SAFERPAY", "SIPS", "ANCV", "PIS", "SPS", "OGONE_LEGACY", "OGONE_DIRECT", "ADYEN", "AXIS", "WIPAY", "WINARCO"];

  public accacProvider: Array<string> = ["SAFER_PAY", "SIPS", "ANCV", "PIS", "SPS", "OGONE_LEGACY", "OGONE_DIRECT", "ADYEN", "AXIS", "WIPAY", "WINARCO"];
  public monthMap = new Map([
    [1, "JANUARY"],
    [2, "FEBRUARY"],
    [3, "MARCH"],
    [4, "APRIL"],
    [5, "MAY"],
    [6, "JUNE"],
    [7, "JULY"],
    [8, "AUGUST"],
    [9, "SEPTEMBER"],
    [10, "OCTOBER"],
    [11, "NOVEMBER"],
    [12, "DECEMBER"]
  ]);

  public status: Array<string> = ["ENABLED", "DISABLED"];

  public merchantSupplierStatus : Array<String>= ["ALL" , "ACTIVE", "DISABLED"];

  public state: Array<string> = ["ONLINE", "OFFLINE"];

  public posType: Array<string> = ["FUEL_STATION"];

  public posDataProvider: Array<string> = ["MERCHANT_WALLET", "MOBYPAY", "HECTRONIC", "GILBARCO", "EFEP", "HUBJECT"];

  public fuellingProviderType: Array<string> = ["MOBYPAY", "IFSF", "HECTRONIC", "GILBARCO", "EFEP", "HUBJECT"];

  public typeEvent: Array<string> = [
    "ABORT_FUELLING",
    "ADD_FUEL_TRANSACTION_RECEIPT",
    "ANCV_WRONG_SEAL",
    "AUTHORIZE",
    "AUTHORIZE_DIRECT",
    "CANCEL",
    "CANCEL_FUELLING",
    "CAPTURE",
    "CARD_DISABLE",
    "CHECK_AUTHORISATION",
    "CREATE_CONTEXT",
    "CREATE_WALLET_DATA",
    "CREATION",
    "CREDIT_FRIEND",
    "CREDIT_VOUCHER",
    "DEBIT_VOUCHER",
    "DELETE",
    "DELETE_MERCHANT",
    "DELETE_POS",
    "DELETE_ACCEPTANCE_ACCOUNT",
    "DELETE_SUPPLIER",
    "DELETE_BY_MERCHANT_ID",
    "DELETE_BY_MERCHANT_ID_AND_SUPPLIER_ID",
    "DELETE_BY_SUPPLIER_ID",
    "DO_FINANCIAL_ADVICE",
    "FIND",
    "GET_BALANCE",
    "GET_CONTRACT",
    "GET_TRANSACTION_BY_COUNTER",
    "GET_TRANSACTION_BY_DATE",
    "GET_FUELLING_STATE",
    "GET_FUEL_TRANSACTION_RECEIPT",
    "GET_PAYMENT_MEAN_DATA",
    "GET_WALLET_DATA",
    "GET_NEAREST_POS",
    "INITIALIZE",
    "INIT_CARD_ADD",
    "REFUND",
    "SAVE_3DS_ENROLLMENT_CONTEXT",
    "SEND_TRANSACTION_DATA",
    "SIGNIN",
    "STATE",
    "START_FUELLING",
    "UPDATE",
    "UPDATE_FUELLING_STATE",
    "VALIDATE_ACCEPTANCE_ACCOUNT_CREDENTIALS",
    "WALLET_ACTIVATION",
    "WALLET_CARD_ADD",
    "WALLET_CARD_DELETE",
    "PIS_GET_STATUS",
    "PIS_INITIALIZE_PAYMENT",
    "PIS_RELEASE_PAYMENT",
    "PAYMENT_PAGE_INITIALIZE",
    "TRANSACTION_HISTORIZE"
  ];

  public paymentMeans: Array<string> = [
    "ACCORD",
    "ACCORD_KDO",
    "AMEX",
    "ANCV",
    "AURORE",
    "BCACUP",
    "BCMC",
    "CB",
    "CVA",
    "MAESTRO",
    "MASTERCARD",
    "POSTFINANCE",
    "SOFINCO",
    "VISA",
    "VISA_ELECTRON",
    "VPAY",
    "ALIPAY",
    "BANCONTACT",
    "BONUS",
    "DINERS",
    "DIRECTDEBIT",
    "EPRZELEWY",
    "EPS",
    "GIROPAY",
    "IDEAL",
    "INVOICE",
    "JCB",
    "MYONE",
    "PAYPAL",
    "PAYDIREKT",
    "POSTCARD",
    "SAFERPAYTEST",
    "SOFORT",
    "TWINT",
    "UNIONPAY",
    "SEPA_MANDATE",
    "BANK_TRANSFER",
    "WINARCO",
    "TAMOIL",
    "UNKNOWN"
  ]

  public allErrors: Array<string> = [
    "CARD_NOT_FOUND",
    "PAN NOT SUPPORTED",
    "PAYMENT_MEAN_NOT_FOUND",
    "3DS FAILED",
    "PAYMENT_MEAN_EXPIRED",
    "CARD_CVC_INVALID",
    "PAYMENT_MEAN_NOT_ACCEPTED",
    "PAYMENT_MEAN_BRAND_NOT_SUPPORTED",
    "PAYMENT_MEAN_FIELD_NOT_SUPPORTED",
    "PAYMENT_MEAN_FIELD_NOT_COMPLIANT",
    "CONTRACT_NOT_FOUND",
    "CACHE_ENTRY_NOT_FOUND",
    "MISSING_REQUIRED_DATA",
    "Event not found",
    "KEYCLOAK_COMMUNICATION_ERROR",
    "NO_AUTHENTICATION_DETECTED",
    "ACCEPTANCE_ACCOUNT_NOT_FOUND",
    "NO_PSP_CONTRACT",
    "FUELLING_PROVIDER_ACCOUNT_NOT_FOUND",
    "PARAMETERS INVALID",
    "ROLE_NOT_FOUND",
    "CUSTOMER_NOT_FOUND",
    "CHECK_BALANCE_EXCEPTION",
    "VOUCHER_EXCEPTION",
    "CONTEXT_NOT_FOUND",
    "BAD_TRANSACTION_STATUS",
    "AUTHORIZATION_DECLINED",
    "INSUFFICIENT_FUNDS",
    "TRANSACTION_ALREADY_CAPTURED",
    "CURRENCY_NOT_SUPPORTED",
    "DUPLICATE_TRANSACTION_REFERENCE",
    "TRANSACTION_DECLINED",
    "PIS_INVALID_PARAMETERS",
    "PIS_ERROR_PAYMENT_MEAN_NOT_CONFIGURED",
    "PIS_ERROR_DATA_STORE",
    "PIS_MERCHANT_UNKNOWN",
    "TRANSACTION_CANCELLED",
    "TRANSACTION_REFUSED",
    "TRANSACTION_PENDING",
    "TECHNICAL_ERROR",
    "BACKEND_COMMUNICATION_ERROR",
    "BACKEND_COMMUNICATION_TIMEOUT",
    "PSP_CREDENTIALS_BAD_REQUEST",
    "OPERATION_FORBIDDEN",
    "UNAUTHORIZED",
    "AUTHORIZATION_HOST_UNREACHABLE",
    "PRODUCT_NOT_ALLOWED",
    "PIS_ERROR_CONFIGURATION",
    "PIS_ERROR_AUTHENTICATION",
    "PIS_ERROR_SIGNATURE_CREATION",
    "EXTERNAL_SERVICE_BAD_REQUEST",
    "NOZZLE_TIMED_OUT",
    "PUMP_IN_USE",
    "FAULTY_PUMP",
    "PUMP_TEMPORARILY_UNAVAILABLE",
    "STATION_UNKNOWN_OR_UNAVAILABLE",
    "PRODUCT_NOT_ON_PUMP",
    "PRODUCT_UNAVAILABLE",
    "PAYMENT_TYPE_UNKNOWN",
    "FUEL_TRANSACTION_ALREADY_FINISHED",
    "FUEL_TRANSACTION_CONTEXT_NOT_FOUND",
    "OPERATION_MODE_NOT_ALLOWED",
    "WALLET_NOT_FOUND",
    "WALLET_ALREADY_EXISTS",
    "WALLET_ID_NOT_COMPLIANT",
    "REPORTING_COUNT_TOO_HIGH"
  ];

  public alertTypes: Array<string> = [
    "DRP_TO_PROD_SWITCH_START",
    "DRP_TO_PROD_SWITCH_END",
    "PROD_TO_DRP_SWITCH_START",
    "PROD_TO_DRP_SWITCH_END"
  ];

  public currencies: Array<string> = [
    "EUR",
    "USD",
    "GBP",
    "NOK",
    "RUB",
    "KZT",
    "EGP",
    "IRR",
    "PKR",
    "AOA",
    "HUF",
    "UAH"
  ]

  public emailRegex: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$';
  public phoneRegex: string = '^([\+]?[(]?[0-9]{3}[)]?)?([-\s\.]?[0-9]{3}[-\s\.]?)?[0-9]{4,6}$';
  public zipRegex: string = "^([A-Za-z0-9]+([ -]?[A-Za-z0-9])*){4,15}$";
  public nameRegex: string = "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$";
  public contactNameRegex: string = "^[a-zéèêâïîëäôöçA-Z]+[ -]?[a-zéèêâïîëäôöçA-Z]+$";
  public latitudeRegex: string = "^(\\+|-)?(?:90(?:(?:\\.0{1,15})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,15})?))$";
  public longitudeRegex: string = "^(\\+|-)?(?:180(?:(?:\\.0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,15})?))";


  fraudLiabilityItems: Array<boolean> = Array<boolean>(true, false);

  constructor(public router: Router) { }

  ngOnInit() {
  }

  getCountrys(): Array<Country> {
    return this.countrys;
  }

  getTransactionStatus(): Array<string> {
    return this.transactionStatus;
  }

  getTransactionStates(): Array<string> {
    return this.transactionStates;
  }

  getPaymentMeans(): Array<string> {
    return this.paymentMeans;
  }

  getStatus(): Array<string> {
    return this.status;
  }

  getMerchantSupplierStatus():Array<String>{
    return this.merchantSupplierStatus;
  }

  getState(): Array<string> {
    return this.state;
  }

  getPosType(): Array<string> {
    return this.posType;
  }

  getFuellingProviderType(): Array<string> {
    return this.fuellingProviderType;
  }

  getAccacProvider(): Array<string> {
    return this.accacProvider;
  }

  getCurrencies(): Array<string> {
    return this.currencies;
  }

  public getTypeEvent(): Array<string> {
    return this.typeEvent;
  }

  public getAlertTypes(): Array<string> {
    return this.alertTypes;
  }

  public getPosDataProvider(): Array<string> {
    return this.posDataProvider;
  }

  public getAllErrors(): Array<string> {
    return this.allErrors;
  }

  redirectToPage(routeName: string, id: string) {
    this.router.navigateByUrl(`/${routeName}/${id}`);
  }

  public getDecimalValue(value: number) {
    if (value > 0)
      return value / 100;
    else
      return 0;
  }

  public getRandomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for ( var i = 0; i < length; i++ ) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
}

}
